import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import useCoveredSiblings from '../utils/useCoveredSiblings';
import { sentences } from '../../../shared/cartStartWait';
import '../styles/checkoutWaitPanel.css';

const CheckoutWaitPanel = ({ lead, title, detail }) => {
  const overlayRef = useRef(null);
  const panelRef = useRef(null);
  useCoveredSiblings(overlayRef);

  useEffect(() => {
    panelRef.current.focus();
  }, []);

  return (
    <div className="checkout-wait-overlay" ref={overlayRef}>
      <div className="checkout-wait-panel" role="status" aria-live="polite" tabIndex={-1} ref={panelRef}>
        <img src="/uploading-loading.gif" alt="" className="checkout-wait-panel-spinner" />
        {lead ? (
          <p className="checkout-wait-panel-lead">
            <strong>{lead}</strong>
          </p>
        ) : null}
        <p className="checkout-wait-panel-title">
          {sentences(title).map((sentence) => (
            <strong key={sentence} className="d-block">{sentence}</strong>
          ))}
        </p>
        <p className="checkout-wait-panel-detail">{detail}</p>
      </div>
    </div>
  );
};

CheckoutWaitPanel.propTypes = {
  lead: PropTypes.string,
  title: PropTypes.string.isRequired,
  detail: PropTypes.string.isRequired,
};

export default CheckoutWaitPanel;
